// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.support-link {
    color: var(--blutorange);
    border: 1px solid var(--blutorange);
    border-radius: 5px;
    padding: 3px;
    margin-top: 20px;
    display: inline-block;
}

.notfall-description {
    font-family: 'Circular', sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/components/notfallnummern/Notfallnummern.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,mCAAmC;IACnC,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,mCAAmC;AACvC","sourcesContent":[".support-link {\n    color: var(--blutorange);\n    border: 1px solid var(--blutorange);\n    border-radius: 5px;\n    padding: 3px;\n    margin-top: 20px;\n    display: inline-block;\n}\n\n.notfall-description {\n    font-family: 'Circular', sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
